import { openDB } from 'idb';

const DB_NAME = 'openhasp-designer-themes';
const STORE_NAME = 'themes';
const DB_VERSION = 1;

let dbPromise;

function getDB() {
    if (!dbPromise) {
        dbPromise = openDB(DB_NAME, DB_VERSION, {
            upgrade(db) {
                if (!db.objectStoreNames.contains(STORE_NAME)) {
                    db.createObjectStore(STORE_NAME, { keyPath: 'id' });
                }
            },
        });
    }
    return dbPromise;
}

export async function listThemes() {
    const db = await getDB();
    const themes = await db.getAll(STORE_NAME);
    return themes.sort((a, b) => String(a.name).localeCompare(String(b.name)));
}

export async function getTheme(id) {
    const db = await getDB();
    return db.get(STORE_NAME, id);
}

export async function saveTheme(theme) {
    const db = await getDB();
    const now = Date.now();
    const existing = theme.id ? await db.get(STORE_NAME, theme.id) : null;
    const row = {
        ...existing,
        ...theme,
        id: theme.id || globalThis.crypto?.randomUUID?.() || `theme-${now}-${Math.random().toString(16).slice(2)}`,
        createdAt: existing?.createdAt ?? now,
        updatedAt: now,
    };
    await db.put(STORE_NAME, row);
    return row;
}

export async function deleteTheme(id) {
    const db = await getDB();
    await db.delete(STORE_NAME, id);
}

